export default "<div class=\"app-screen-size-error\">\n\n  Sorry, currently we don't support low resolution screens. Will fix it soon!\n\n</div>\n"